var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review"},[_c('InfoData'),_c('TableData'),_c('el-dialog',{staticClass:"cre",attrs:{"visible":_vm.dialogVisible,"title":"确认信息","width":"1280px","append-to-body":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('CreateUser',{on:{"test":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }